import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { Link } from './ui';
import logo from '../images/marcloud-consulting-logo.svg';
import logoCreative from '../images/marcloud-creative-logo.svg';

const StyledLogo = styled(Link)`
  display: inline-block;
`;

const StyledImage = styled.img`
  width: 100%;
`;

const Logo = ({ alt, ...props }) => {
  const {
    datoCmsSite: {
      globalSeo: { siteName },
    },
  } = useStaticQuery(graphql`
    query LogoQuery {
      datoCmsSite {
        globalSeo {
          siteName
        }
      }
    }
  `);

  return (
    <StyledLogo to="/" {...props}>
      <StyledImage
        src={process.env.GATSBY_SITE_THEME === 'creative' ? logoCreative : logo}
        alt={siteName}
        loading="lazy"
      />
    </StyledLogo>
  );
};

export default Logo;
